// react
import { ChangeEvent, ReactNode } from 'react';

// types
import { Pagination as PaginationProps } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useSearchParams } from 'react-router-dom';

// mui
import { Grid, Pagination, SelectChangeEvent, Typography } from '@mui/material';

// fields
import { SelectRowsPerPage } from '../../fields/SelectRowsPerPage/SelectRowsPerPage';

// props
export interface TableFooterProps {
	footer?: ReactNode;
	hasSelectRows?: boolean;
	numShowing?: number;
	onChangePage?: (e: ChangeEvent<unknown>, page: number) => void;
	onChangeRowsPerPage?: (e: SelectChangeEvent<unknown>, child: ReactNode) => void;
	pagination: PaginationProps;
}

export const TableFooter = ({
	footer,
	hasSelectRows = false,
	onChangePage,
	onChangeRowsPerPage,
	pagination,
}: TableFooterProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [searchParams, setSearchParams] = useSearchParams();

	// vars
	let endNum = pagination.page * pagination.perPage;
	let startNum = endNum - pagination.perPage + 1;

	if (startNum === 0) {
		startNum = 1;
	}

	if (pagination.total && endNum > pagination.total) {
		endNum = pagination.total;
	}

	const handleChangePage = (e: ChangeEvent<unknown>, page: number) => {
		if (onChangePage) {
			onChangePage(e, page);
		}

		// set search param
		searchParams.set('page', String(page));
		setSearchParams(searchParams);
	};

	return (
		<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
			<Grid item>
				<Grid alignItems="center" container spacing={2}>
					<Grid item xs={true}>
						<Grid alignItems="center" container spacing={{ xs: 1, md: 2 }}>
							<Grid item>
								<Typography variant="caption">
									{t('tableShowing', { end: endNum, start: startNum, total: pagination.total })}
								</Typography>
							</Grid>
							{hasSelectRows && (
								<Grid item>
									<SelectRowsPerPage
										defaultValue={pagination.perPage}
										onChange={onChangeRowsPerPage}
									/>
								</Grid>
							)}
							{footer && (
								<Grid item xs={12} md="auto">
									{footer}
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs="auto">
				<Pagination
					color="primary"
					count={pagination.totalPages}
					onChange={handleChangePage}
					shape="rounded"
					page={pagination.page}
				/>
			</Grid>
		</Grid>
	);
};
